import styled, { css } from 'styled-components';
import { SPACING_12 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import { TRANSPARENT } from '@nokia-csf-uxr/freeform-design-tokens/tokens/colors';
import { MICRO } from '@nokia-csf-uxr/freeform-design-tokens/tokens/typography';
import { RADIUS_2 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/border-radius';

const MAX_WIDTH = '15.625rem';

export default {
  TooltipTextContainer: styled.div`
    max-width: ${({ isText }) => (isText ? MAX_WIDTH : 'none')};
    width: ${({ width }) => width};
    width: ${({ height }) => height};
    padding: ${SPACING_12};
    border-radius: ${RADIUS_2};
    background: ${({ isText, $theme }) => (isText ? $theme.container : TRANSPARENT)};
    color: ${({ $theme }) => $theme.content};
    ${css(MICRO)}
  `
};